import { getCookie, setCookie } from "./cookies";

export function popup() {
  
  $(document).ready(function() {
    
    if($('.popup-content-inner .woocommerce-error').length) {
      $('.popup-content-inner .woocommerce-error').closest('.popup-content').after('<div class="popup-overlay open"></div>').fadeIn();
      $('html,body').addClass("noscroll");
    }
    
    if($("#global-subscribe-popup").length) {
      setTimeout(function() {
        if(getCookie('global-subscribe-closed') != 1) {
          $('#global-subscribe-popup').after('<div class="popup-overlay open"></div>').fadeIn();
          $('html,body').addClass("noscroll");
        }
      }, 5000);
    }
    
    if($("#custom-popup").length) {
      setTimeout(function() {
        if(getCookie('custom-popup-closed-new') != 1) {
          $('#custom-popup').after('<div class="popup-overlay open"></div>').fadeIn();
          $('html,body').addClass("noscroll");
        }
      }, 5000);
    }
    
    $('body').on('click', '.hire-me-popup__form .hire-me-popup__cancel', function(e) {
      e.preventDefault();
      $(this).closest('.popup-content').find('.popup-close').click();
    });
      
    $('body').on('click', 'a[href$="-popup"]', function(e) {
      e.preventDefault();
      
      if($(this).hasClass('vimeo'))
        $($(this).attr('href')).find(".popup-content-inner").html('<iframe allowfullscreen="allowfullscreen" allow="autoplay; fullscreen" src="//player.vimeo.com/video/'+$(this).data('src')+'?autoplay=1&hd=1&show_title=1&show_byline=1&show_portrait=0&fullscreen=1&color=20f384" scrolling="no"></iframe>');
      else if($(this).hasClass('video_popup'))
        $($(this).attr('href')).find(".popup-content-inner").html('<iframe allowfullscreen="allowfullscreen" allow="autoplay; fullscreen" src="https://www.youtube-nocookie.com/embed/'+$(this).data('src')+'?autoplay=1&autohide=1&fs=1&rel=0&hd=1&wmode=transparent&enablejsapi=1&html5=1&controls=1&showinfo=0" scrolling="no"></iframe>');
      else if($(this).hasClass('portfolio_popup')) {
        var popup_content = $(this).closest('.portfolio-item-wrapper').clone();
        
        var author_id = $(this).data('author-id');
        var author_title = $(this).data('author-title');
        var author_avatar = $(this).data('author-avatar');
        
        var portfolio_id = $(this).data('portfolio-id');
        
        $(popup_content).find('video').attr('autoplay', 'true');
        $(popup_content).find('video').attr('controls', 'true');
        $(popup_content).find('.portfolio-item-author-wrapper').append('<a href="#portfolio-hire-me-popup" class="hire-me-popup button"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="envelope" class="svg-inline--fa fa-envelope fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"></path></svg> Hire me</a>');
        $($(this).attr('href')).find(".popup-content-inner").html($(popup_content).html());
        
        $('.portfolio-hire-me-popup .portfolio-item-author-image-name').html('<img class="custom-avatar" src="' + author_avatar + '" alt="' + author_title + '" />Message ' + author_title);
        $('.portfolio-hire-me-popup #hire-me-form input[name="author_id"]').val(author_id);
        $('.portfolio-hire-me-popup #hire-me-form input[name="portfolio_id"]').val(portfolio_id);
        $('.portfolio-hire-me-popup #hire_me_message').attr('placeholder', 'Message ' + author_title);
        
      }
      else if($(this).hasClass('portfolio_edit_popup')) {
      
        var popup_content = $(this).closest('.portfolio-item-wrapper').clone();
        
        var portfolio_id = $(this).data('portfolio-id');
        
        var attachment_thumbnail_id = $(this).data('attachment-thumbnail-id');
        var attachment_resource_id = $(this).data('attachment-resource-id');
        
        var resource_name = $(popup_content).find('.portfolio-item-name-wrapper').text().trim();
        var resource_description = $(popup_content).find('.portfolio-item-description').text().trim();
        var resource_category = $(this).data('portfolio-category');
        var resource_software = $(this).data('portfolio-software');
        
        var video_src = $(popup_content).find('video source').attr('src');
        var img_src = $(popup_content).find('.portfolio-image').attr('src');
        var thumbnail_src = $(popup_content).find('.portfolio-thumbnail').attr('src');
        
        $('#portfolio-edit-popup .hideonupload').hide();
        $('#portfolio-edit-popup .drop-file-wrapper').addClass('portfolio-uploaded');
        $('#portfolio-edit-popup #drop_file_area').attr('data-attachment-id', attachment_resource_id);
        $('#portfolio-edit-popup .uploadnotice').removeClass('show');
        
        $('#portfolio-edit-popup .button-save').attr('data-portfolio-id', portfolio_id);
        $('#portfolio-edit-popup .button-delete').attr('data-portfolio-id', portfolio_id);
        
        $('#portfolio-edit-popup #drop_file_area .portfolio-name').val(resource_name);
        $('#portfolio-edit-popup #drop_file_area .portfolio-description').val(resource_description);
        $('#portfolio-edit-popup #drop_file_area .portfolio-category').val(resource_category);
        
        var selected_software = resource_software.split(',');
        $.each(selected_software, function(i, v) {
          $('#portfolio-edit-popup #drop_file_area .choices.details_software :checkbox[value="'+v+'"]').prop("checked", true);
        });
        
        var item_content = '<span class="media-resource" data-attachment-id="'+attachment_thumbnail_id+'" data-attachment-type="image"><div class="ordering"><a href="#" class="prev">&lt;</a><a href="#" class="next">&gt;</a></div><img src="'+thumbnail_src+'"><input type="hidden" class="portfolio-name" name="portfolio-name" id="portfolio-name-'+attachment_thumbnail_id+'" value="'+resource_name+'"><input type="hidden" class="portfolio-description" name="portfolio-description" id="portfolio-description-'+attachment_thumbnail_id+'" value="'+resource_description+'"><input type="hidden" class="portfolio-category" name="portfolio-category" id="portfolio-category-'+attachment_thumbnail_id+'" value="'+resource_category+'"><input type="hidden" class="portfolio-software" name="portfolio-software" id="portfolio-software-'+attachment_thumbnail_id+'" value="'+resource_software+'"><a class="delete-resource" href="#"><svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px"><path d="M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z"></path></svg></a></span>';

        if($(this).data('portfolio-type').indexOf('video') !== -1) {
          
          item_content += '<span class="media-resource active" data-attachment-id="'+attachment_resource_id+'" data-attachment-type="video"><div class="ordering"><a href="#" class="prev">&lt;</a><a href="#" class="next">&gt;</a></div><video><source src="'+video_src+'" type="video/mp4"></video><input type="hidden" class="portfolio-name" name="portfolio-name" id="portfolio-name-'+attachment_resource_id+'" value="'+resource_name+'"><input type="hidden" class="portfolio-description" name="portfolio-description" id="portfolio-description-'+attachment_resource_id+'" value="'+resource_description+'"><input type="hidden" class="portfolio-category" name="portfolio-category" id="portfolio-category-'+attachment_resource_id+'" value="'+resource_category+'"><input type="hidden" class="portfolio-software" name="portfolio-software" id="portfolio-software-'+attachment_resource_id+'" value="'+resource_software+'"><a class="delete-resource" href="#"><svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px"><path d="M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z"></path></svg></a></span>';
          
          $('#portfolio-edit-popup #drop_file_area img.portfolio-media').hide();
          $('#portfolio-edit-popup #drop_file_area video').show();
          $('#portfolio-edit-popup #drop_file_area video source').attr('src', video_src);
          $('#portfolio-edit-popup #drop_file_area video').attr('data-attachment-id', attachment_resource_id);
          var vid = $('#portfolio-edit-popup .drop-file-wrapper video')[0];
          if(vid) {
            vid.load();
            vid.play();
          }
        }
        else {
          
          item_content += '<span class="media-resource" data-attachment-id="'+attachment_resource_id+'" data-attachment-type="image"><div class="ordering"><a href="#" class="prev">&lt;</a><a href="#" class="next">&gt;</a></div><img src="'+img_src+'" /><input type="hidden" class="portfolio-name" name="portfolio-name" id="portfolio-name-'+attachment_resource_id+'" value="'+resource_name+'"><input type="hidden" class="portfolio-description" name="portfolio-description" id="portfolio-description-'+attachment_resource_id+'" value="'+resource_description+'"><input type="hidden" class="portfolio-category" name="portfolio-category" id="portfolio-category-'+attachment_resource_id+'" value="'+resource_category+'"><input type="hidden" class="portfolio-software" name="portfolio-software" id="portfolio-software-'+attachment_resource_id+'" value="'+resource_software+'"><a class="delete-resource" href="#"><svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px"><path d="M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z"></path></svg></a></span>';
          
          $('#portfolio-edit-popup #drop_file_area video').hide();
          $('#portfolio-edit-popup #drop_file_area img.portfolio-media').show();
          $('#portfolio-edit-popup #drop_file_area .portfolio-media').attr('src', img_src);
          $('#portfolio-edit-popup #drop_file_area .portfolio-media').attr('data-attachment-id', attachment_resource_id);
        }
        
        
        var uploaded_output = '<div id="uploaded_file">'+item_content+'<span class="add-new" style="display: none;"><a href="#edit_portfolio_media">+</a></span><div class="add-new-warning" style="display: none;">You must add one more resource to continue</div></div>';
        
        $('#portfolio-edit-popup #uploaded_file').html(uploaded_output);
        
        $('#portfolio-edit-popup #uploaded_file .add-new').hide();
        $('#portfolio-edit-popup #uploaded_file .add-new-warning').hide();
        $('#portfolio-edit-popup .action-area').show();
        
        $('#portfolio-edit-popup #drop_file_area .portfolio-name').show();
        $('#portfolio-edit-popup #drop_file_area .portfolio-description').show();
        $('#portfolio-edit-popup #drop_file_area .portfolio-category-wrapper').show();
        $('#portfolio-edit-popup #drop_file_area .portfolio-software-wrapper').show();
        
        $('#portfolio-edit-popup #uploaded_file span .ordering').removeClass('disabled');
      
      }
      
      $($(this).attr('href')).after('<div class="popup-overlay open"></div>').fadeIn();
      $('html,body').addClass("noscroll");
    });
    
    $('.wp-block-button.video_popup').click(function(e) {
      $('.video-popup.popup-content .popup-content-inner').html('<iframe allowfullscreen="allowfullscreen" allow="autoplay; fullscreen" src="https://www.youtube-nocookie.com/embed/'+$(this).attr('id')+'?autoplay=1&autohide=1&fs=1&rel=0&hd=1&wmode=transparent&enablejsapi=1&html5=1&controls=1&showinfo=0" scrolling="no"></iframe>');
      $('.video-popup.popup-content').after('<div class="popup-overlay open"></div>').fadeIn();
      $('html,body').addClass("noscroll");
    });
    
    $('.popup-close').click(function(e) {
      e.preventDefault();
      $(this).parent().fadeOut();
      
      if($(this).parent().hasClass('video-popup')) {
        $(this).find("+ .popup-content-inner").html('');
      }
      
      if($(this).parent().hasClass('global-subscribe-popup')) {
        setCookie('global-subscribe-closed', 1, 365);
      }
      
      if($(this).parent().hasClass('custom-popup')) {
        setCookie('custom-popup-closed-new', 1, 30);
      }
      
      if($(this).parent().hasClass('portfolio-listing-popup') || $(this).parent().hasClass('portfolio-edit-popup') || $(this).parent().hasClass('portfolio-upload-popup')) {
        var media = $(this).parent().find("video").get(0);
        
        if(media) {
          media.pause();
          media.currentTime = 0;
        }
      }
      
      if(!$(this).parent().hasClass('portfolio-remove-popup')) {
        $('.popup-overlay').fadeOut();
        $('html,body').removeClass("noscroll");
      }
      
    });
    
    $('.button-popup-close').click(function(e) {
      //e.preventDefault();
      var $popup_content = $(this).closest(".popup-content");
      
      $popup_content.fadeOut();
      
      if($popup_content.hasClass('video-popup')) {
        $(this).find("+ .popup-content-inner").html('');
      }
      
      if($popup_content.hasClass('global-subscribe-popup')) {
        setCookie('global-subscribe-closed', 1, 365);
      }
      
      if($popup_content.hasClass('custom-popup')) {
        setCookie('custom-popup-closed-new', 1, 30);
      }
      
      $('.popup-overlay').fadeOut();
      $('html,body').removeClass("noscroll");
    });
    
    $('body').on('click', '.popup-overlay', function(e) {
      e.preventDefault();
      $('.popup-content').fadeOut();
      $('html,body').removeClass("noscroll");
      $(this).fadeOut().remove();
    });
    
    document.addEventListener('keydown', function(event) {
      if(event.keyCode == 27) {
        $('.popup-close').click();
      }
    });
    
    function validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }

    $("body.logged-in #free-lecture-form .free-lecture-popup__button").click(function(e) {
      e.preventDefault();
      
      // honeypot check
      if($('#free-lecture-form [name="email"]').val() != '')
        return;
      
      var $this = $(this).closest("form");
      
      if(!($this).find('[name="agree"]').is(":checked")) {
        $this.find(".success_message").text("You must agree to our terms!").fadeIn();
        return;
      }

      $this.find('[data-hide-on-success]').hide();
      
      $this.find(".success_message").text("Please wait...").fadeIn();
      
      var email = $('#newsletter-email-popup').val();
      var course_id = $('#free-lecture-popup').data('course-id');
      var klaviyo_list_id = $('#free-lecture-popup input[name="g"]').val();
      
      grecaptcha.ready(function() {
        grecaptcha.execute('6LdgGC4gAAAAANuuHvRlf7bFSBZHccadtzjWfkS0', {action: 'submit'}).then(function(token) {
          
          $.ajax({
            method: "POST",
            dataType: 'json',
            url: theme_vars.ajaxurl,
            data: {
              action: "assign_free_user",
              email: email,
              course_id: course_id,
              recaptcha_token: token,
              klaviyo_list_id: klaviyo_list_id,
            },
            success: function(response) {
              if(typeof sendinblue === "object")
                sendinblue.track('free_lecture', {'email': email, 'course_id': course_id});
              location.reload();
            },
            error: function(response) {
              $this.find(".success_message").text("Forbidden");
            }
          });
          
        });
      });
      
      

    });

    $("body:not(.logged-in) #free-lecture-form .free-lecture-popup__button").click(function(e) {
      e.preventDefault();
      
      // honeypot check
      if($('#free-lecture-form [name="email"]').val() != '')
        return;
      
      var $this = $(this).closest("form");
      
      $this.find(".success_message").text("Please wait...").fadeIn();
      
      if(!validateEmail($this.find("#newsletter-email-popup").val())) {
        $this.find(".success_message").text("Please provide a valid email address!").fadeIn();
        return;
      }
      if(!($this).find('[name="agree"]').is(":checked")) {
        $this.find(".success_message").text("You must agree to our terms!").fadeIn();
        return;
      }
      
      var email = $('#newsletter-email-popup').val();
      var course_id = $('#free-lecture-popup').data('course-id');
      var klaviyo_list_id = $('#free-lecture-popup input[name="g"]').val();
      
      grecaptcha.ready(function() {
        
        grecaptcha.execute('6LdgGC4gAAAAANuuHvRlf7bFSBZHccadtzjWfkS0', {action: 'submit'}).then(function(token) {
          
          $.ajax({
            method: "POST",
            dataType: 'json',
            url: theme_vars.ajaxurl,
            data: {
              action: "add_free_user",
              email: email,
              course_id: course_id,
              recaptcha_token: token,
              klaviyo_list_id: klaviyo_list_id,
            },
            success: function(response) {
              
              if(response.data.new_user == 1) {
                $this.find('[data-hide-on-success]').hide();
                $this.find(".success_message").text("We've just sent you an email with details of your free account. To finish signing up, please follow the instructions in the email.");
                
                if(typeof sendinblue === "object")
                  sendinblue.track('free_lecture', {'email': email, 'course_id': course_id});
              }
              else {
                $this.find('[data-hide-on-success]').hide();
                
                if(response.data.already_enrolled == 1)
                  $this.find(".success_message").text("You are already enrolled in this course. Please sign in. Redirecting...");
                else {
                  $this.find(".success_message").text("Thank you! Please sign in to access your free lesson. Redirecting...");
                  if(typeof sendinblue === "object")
                    sendinblue.track('free_lecture', {'email': email, 'course_id': course_id});
                }
                setTimeout(function() {
                  window.location.href = response.data.url;
                }, 2000);
              }
            },
            error: function(response) {
              $this.find(".success_message").text("Forbidden");
            }
          });
          
        });
        
      });

    });

    $("body.logged-in .joinFreeCourse").click(function(e) {
      e.preventDefault();
      
      var course_id = $(this).data('course-id');
      var klaviyo_list_id = $(this).data('klaviyo-id');

      $(this).text("Please wait...").prop('disabled', true);

      if(typeof grecaptcha === "object") {
      
        grecaptcha.ready(function() {
          grecaptcha.execute('6LdgGC4gAAAAANuuHvRlf7bFSBZHccadtzjWfkS0', {action: 'submit'}).then(function(token) {
            
            $.ajax({
              method: "POST",
              dataType: 'json',
              url: theme_vars.ajaxurl,
              data: {
                action: "join_free_course",
                course_id: course_id,
                klaviyo_list_id: klaviyo_list_id,
                recaptcha_token: token,
              },
              success: function(response) {
                location.reload();
              },
              error: function(response) {
                $this.find(".success_message").text("Forbidden");
              }
            });
            
          });
        });  
        
      }
      else {

        $.ajax({
          method: "POST",
          dataType: 'json',
          url: theme_vars.ajaxurl,
          data: {
            action: "join_free_course",
            course_id: course_id,
            klaviyo_list_id: klaviyo_list_id,
            recaptcha_token: token,
          },
          success: function(response) {
            location.reload();
          },
          error: function(response) {
            $this.find(".success_message").text("Forbidden");
          }
        });

      }

    });

    $("body:not(.logged-in) #join-course-form .free-lecture-popup__button").click(function(e) {
      e.preventDefault();
      
      // honeypot check
      if($('#join-course-form [name="email"]').val() != '')
        return;
      
      var $this = $(this).closest("form");
      
      $this.find(".success_message").text("Please wait...").fadeIn();
      
      if(!validateEmail($this.find("#join-course-email-popup").val())) {
        $this.find(".success_message").text("Please provide a valid email address!").fadeIn();
        return;
      }
      if(!($this).find('[name="agree"]').is(":checked")) {
        $this.find(".success_message").text("You must agree to our terms!").fadeIn();
        return;
      }
      
      var email = $('#join-course-email-popup').val();
      var course_id = $('#join-course-popup').data('course-id');
      var klaviyo_list_id = $('#join-course-popup input[name="g"]').val();

      if(typeof grecaptcha === "object") {
      
        grecaptcha.ready(function() {
          
          grecaptcha.execute('6LdgGC4gAAAAANuuHvRlf7bFSBZHccadtzjWfkS0', {action: 'submit'}).then(function(token) {
            
            $.ajax({
              method: "POST",
              dataType: 'json',
              url: theme_vars.ajaxurl,
              data: {
                action: "join_free_course_register",
                email: email,
                course_id: course_id,
                recaptcha_token: token,
                klaviyo_list_id: klaviyo_list_id,
              },
              success: function(response) {
                
                if(response.data.new_user == 1) {
                  $this.find('[data-hide-on-success]').hide();
                  $this.find(".success_message").text("We've just sent you an email with details of your free account. To finish signing up, please follow the instructions in the email.");
                  
                  if(typeof sendinblue === "object")
                    sendinblue.track('free_lecture', {'email': email, 'course_id': course_id});
                }
                else {
                  $this.find('[data-hide-on-success]').hide();
                  
                  if(response.data.already_enrolled == 1)
                    $this.find(".success_message").text("You are already enrolled in this course. Please sign in. Redirecting...");
                  else {
                    $this.find(".success_message").text("Thank you! Please sign in to access your course. Redirecting...");
                    if(typeof sendinblue === "object")
                      sendinblue.track('free_lecture', {'email': email, 'course_id': course_id});
                  }
                  setTimeout(function() {
                    window.location.href = response.data.url;
                  }, 2000);
                }
              },
              error: function(response) {
                $this.find(".success_message").text("Forbidden");
              }
            });
            
          });
          
        });

      }
      else {

        $.ajax({
          method: "POST",
          dataType: 'json',
          url: theme_vars.ajaxurl,
          data: {
            action: "join_free_course_register",
            email: email,
            course_id: course_id,
            klaviyo_list_id: klaviyo_list_id,
          },
          success: function(response) {
            
            if(response.data.new_user == 1) {
              $this.find('[data-hide-on-success]').hide();
              $this.find(".success_message").text("We've just sent you an email with details of your free account. To finish signing up, please follow the instructions in the email.");
              
              if(typeof sendinblue === "object")
                sendinblue.track('free_lecture', {'email': email, 'course_id': course_id});
            }
            else {
              $this.find('[data-hide-on-success]').hide();
              
              if(response.data.already_enrolled == 1)
                $this.find(".success_message").text("You are already enrolled in this course. Please sign in. Redirecting...");
              else {
                $this.find(".success_message").text("Thank you! Please sign in to access your free lesson. Redirecting...");
                if(typeof sendinblue === "object")
                  sendinblue.track('free_lecture', {'email': email, 'course_id': course_id});
              }
              setTimeout(function() {
                window.location.href = response.data.url;
              }, 2000);
            }
          },
          error: function(response) {
            $this.find(".success_message").text("Forbidden");
          }
        });

      }

    });

    $("#reserve-spot-popup .free-lecture-popup__button").click(function(e) {
      e.preventDefault();
      
      // honeypot check
      if($('#reserve-spot-form [name="email"]').val() != '')
        return;
      
      var $this = $(this).closest("form");
      
      $this.find(".success_message").text("Please wait...").fadeIn();
      
      if(!validateEmail($this.find("#reserve-spot-email-popup").val())) {
        $this.find(".success_message").text("Please provide a valid email address!").fadeIn();
        return;
      }
      if(!($this).find('[name="agree"]').is(":checked")) {
        $this.find(".success_message").text("You must agree to our terms!").fadeIn();
        return;
      }
      
      var email = $('#reserve-spot-email-popup').val();
      var course_id = $('#reserve-spot-popup').data('course-id');

      var klaviyo_list_id = $('#reserve-spot-popup input[name="g"]').val();
      
      if(typeof grecaptcha === "object") {
      
        grecaptcha.ready(function() {
          
          grecaptcha.execute('6LdgGC4gAAAAANuuHvRlf7bFSBZHccadtzjWfkS0', {action: 'submit'}).then(function(token) {
            
            $this.find('[data-hide-on-success]').hide();
            $this.find(".success_message").text("You're registered for the pre-sale!");
            
            if(typeof sendinblue === "object")
              sendinblue.track('reserve_spot', {'email': email, 'course_id': course_id});
            
            $.ajax({
              method: "POST",
              dataType: 'json',
              url: theme_vars.ajaxurl,
              data: {
                action: "send_to_klaviyo",
                email: email,
                recaptcha_token: token,
                klaviyo_list_id: klaviyo_list_id,
              },
              success: function(response) {
                console.log(response);
              },
              error: function(response) {
                console.log(response);
              }
            }); 
            
          });
          
        });
      
      }
      else {
        
        $this.find('[data-hide-on-success]').hide();
        $this.find(".success_message").text("Thanks! You're now registered for the pre-sale!");
        
        if(typeof sendinblue === "object")
          sendinblue.track('reserve_spot', {'email': email, 'course_id': course_id});
        
        $.ajax({
          method: "POST",
          dataType: 'json',
          url: theme_vars.ajaxurl,
          data: {
            action: "send_to_klaviyo",
            email: email,
            klaviyo_list_id: klaviyo_list_id,
          },
          success: function(response) {
            console.log(response);
          },
          error: function(response) {
            console.log(response);
          }
        }); 
      
      }

    });
       
    $("#fifty-off-popup .free-lecture-popup__button").click(function(e) {
      e.preventDefault();
      
      // honeypot check
      if($('#fifty-off-form [name="email"]').val() != '')
        return;
      
      var $this = $(this).closest("form");
      
      $this.find(".success_message").text("Please wait...").fadeIn();
      
      if(!validateEmail($this.find("#fifty-off-email-popup").val())) {
        $this.find(".success_message").text("Please provide a valid email address!").fadeIn();
        return;
      }
      if(!($this).find('[name="agree"]').is(":checked")) {
        $this.find(".success_message").text("You must agree to our terms!").fadeIn();
        return;
      }
      
      var email = $('#fifty-off-email-popup').val();
      var course_id = $('#fifty-off-popup').data('course-id');
      var klaviyo_list_id = 'UJJxAc';
      
      if(typeof grecaptcha === "object") {
      
        grecaptcha.ready(function() {
          
          grecaptcha.execute('6LdgGC4gAAAAANuuHvRlf7bFSBZHccadtzjWfkS0', {action: 'submit'}).then(function(token) {
            
            $this.find('[data-hide-on-success]').hide();
            $this.find(".success_message").text("We've just sent you an email with your 50% off coupon!");
            
            if(typeof sendinblue === "object")
              sendinblue.track('fifty_off_coupon', {'email': email, 'course_id': course_id});
            
            $.ajax({
              method: "POST",
              dataType: 'json',
              url: theme_vars.ajaxurl,
              data: {
                action: "send_to_klaviyo",
                email: email,
                recaptcha_token: token,
                klaviyo_list_id: klaviyo_list_id,
              },
              success: function(response) {
                console.log(response);
              },
              error: function(response) {
                console.log(response);
              }
            }); 
            
          });
          
        });
      
      }
      else {
        
        $this.find('[data-hide-on-success]').hide();
        $this.find(".success_message").text("We've just sent you an email with your 50% off coupon!");
        
        if(typeof sendinblue === "object")
          sendinblue.track('fifty_off_coupon', {'email': email, 'course_id': course_id});
        
        $.ajax({
          method: "POST",
          dataType: 'json',
          url: theme_vars.ajaxurl,
          data: {
            action: "send_to_klaviyo",
            email: email,
            klaviyo_list_id: klaviyo_list_id,
          },
          success: function(response) {
            console.log(response);
          },
          error: function(response) {
            console.log(response);
          }
        }); 
      
      }

    });

  
  });
  
}


// WEBPACK FOOTER //
// ./assets/js/modules/popup.js